import { Box, Button, Typography } from '@mui/material';

// Minimal full-page message with one action, for the pages rendered outside
// <Admin> (no theme / i18nProvider there): tenant bootstrap errors, signed-out
// page, login start failures.
const AuthMessageScreen = ({ title, body, action, onAction }) => (
    <Box
        sx={{
            height: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2,
            padding: '24px',
            textAlign: 'center',
        }}
    >
        <Typography sx={{ fontSize: '18px', fontWeight: 500, fontFamily: `'Roboto', sans-serif`, color: '#364152' }}>
            {title}
        </Typography>
        {body && (
            <Typography sx={{ fontSize: '14px', fontFamily: `'Roboto', sans-serif`, color: '#697586', maxWidth: '480px' }}>
                {body}
            </Typography>
        )}
        {action && (
            <Button variant="contained" onClick={onAction} sx={{ marginTop: '8px' }}>
                {action}
            </Button>
        )}
    </Box>
);

export default AuthMessageScreen;
